/** Server-side score sanity caps for leaderboard submissions. */

export type ScoreValidationInput = {
  score: number;
  level: number;
  simTime: number;
  bestStreak: number;
  totalKills?: number;
};

export type ScoreValidationResult =
  | { ok: true }
  | { ok: false; reason: string };

export function validateScoreSubmission(input: ScoreValidationInput): ScoreValidationResult {
  if (!Number.isFinite(input.score) || input.score < 0) {
    return { ok: false, reason: "invalid_score" };
  }
  if (input.score > 500_000) return { ok: false, reason: "score_cap" };
  if (input.level < 1 || input.level > 25) return { ok: false, reason: "level_cap" };
  if (input.simTime < 0 || input.simTime > 3600) return { ok: false, reason: "time_cap" };
  const maxByTime = Math.floor(input.simTime * 120 + input.level * 800);
  if (input.score > maxByTime * 1.35) return { ok: false, reason: "score_time_mismatch" };
  const totalKills = input.totalKills ?? 0;
  if (input.bestStreak > totalKills && totalKills > 0) {
    return { ok: false, reason: "streak_kill_mismatch" };
  }
  return { ok: true };
}

export type ScoreTier = "scrap" | "bronze" | "silver" | "gold" | "velocity";

export function scoreTier(score: number): ScoreTier {
  if (score >= 20_000) return "velocity";
  if (score >= 12_000) return "gold";
  if (score >= 6_000) return "silver";
  if (score >= 2_500) return "bronze";
  return "scrap";
}

export const TIER_LABELS: Record<ScoreTier, string> = {
  scrap: "Scrap",
  bronze: "Bronze",
  silver: "Silver",
  gold: "Gold",
  velocity: "Velocity",
};
